import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface StockSliceCountedLine {
  partNo: string;
  locallyCounted: number | null;
  previousSystemProvided: number;
  partDescription: string;
  binLocation: string;
}

export interface StockSliceSavedCheck {
  companyId: number;
  depot: string;
  url: string;
  stockCheckRef: string;
  countedLines: StockSliceCountedLine[];
}

export interface StockSliceSingleCheck {
  companyId: number;
  depot: string;
  url: string;
  stockCheckRef: string;
  countedLine: StockSliceCountedLine;
}

export interface StockCheckState {
  savedChecks: StockSliceSavedCheck[];
}

const initialState: StockCheckState = {
  savedChecks: [],
};

export const stockCheckSlice = createSlice({
  name: "stockCheck",
  initialState,
  reducers: {
    clearSavedStockCheck: (state, action: PayloadAction<string>) => {
      if (
        state.savedChecks.filter((e) => {
          return e.stockCheckRef == action.payload;
        }).length > 0
      ) {
        const newState = state.savedChecks.filter((e) => {
          return e.stockCheckRef != action.payload;
        });
        state.savedChecks = newState;
      }
    },
    setPartCountProgress: (
      state,
      action: PayloadAction<StockSliceSavedCheck>
    ) => {
      if (
        state.savedChecks.filter((e) => {
          return (
            e.stockCheckRef == action.payload.stockCheckRef &&
            e.companyId == action.payload.companyId &&
            e.depot == action.payload.depot &&
            e.url == action.payload.url
          );
        }).length > 0
      ) {
        // stock check already exists in Slice, Edit that record

        // get the Index of the Slice object to edit.
        const index = state.savedChecks
          .map((e) => {
            return e.stockCheckRef + e.companyId + e.depot + e.url;
          })
          .indexOf(
            action.payload.stockCheckRef +
              action.payload.companyId +
              action.payload.depot +
              action.payload.url
          );

        // wipe the lines already inside it, so that lines removed on later saves are not retained.
        state.savedChecks[index].countedLines = [];

        // Add the payload into to the slice
        action.payload.countedLines.forEach((line) => {
          if (line.locallyCounted != null) {
            state.savedChecks[index].countedLines.push(line);
          }
        });
      } else {
        // stock check is not in Slice, add it
        const newCheck: StockSliceSavedCheck = {
          stockCheckRef: action.payload.stockCheckRef,
          countedLines: action.payload.countedLines.filter(
            (e) => e.locallyCounted != null
          ),
          companyId: action.payload.companyId,
          depot: action.payload.depot,
          url: action.payload.url,
        };
        state.savedChecks.push(newCheck);
      }
    },
    clearStockSlice: () => {
      return initialState;
    },
  },
});

export const { clearSavedStockCheck, clearStockSlice, setPartCountProgress } =
  stockCheckSlice.actions;

export default stockCheckSlice.reducer;
